import React from 'react';
import LLMIcon from './LLMIcon';

/**
 * ResultView — locked answer list after user choice.
 *
 * Props:
 *   question: string
 *   answers: string[]
 *   answerLlms: string[][]   — e.g. [["deepseek"], ["zhipu","alibaba"], [], ["moonshot"]]
 *   selectedChoice: number
 *   onNext: () => void
 */
function ResultView({ question, answers, answerLlms, selectedChoice, onNext }) {
  return (
    <div className="result-view">
      <h2 className="question-text">{question}</h2>

      <div className="options-list result-mode">
        {answers.map((answer, index) => {
          const llms = (answerLlms && answerLlms[index]) || [];
          return (
            <div
              key={index}
              className={`option-button result-option ${
                index === selectedChoice ? 'selected' : ''
              }`}
            >
              <span className="option-text">{answer}</span>
              {llms.length > 0 && (
                <span className="answer-llm-icons">
                  {llms.map((provider, pi) => (
                    <LLMIcon key={pi} provider={provider} size={24} />
                  ))}
                </span>
              )}
            </div>
          );
        })}
      </div>

      <div className="result-actions">
        <button className="btn btn-primary" onClick={onNext}>
          Next Question
        </button>
      </div>
    </div>
  );
}

export default ResultView;
